<template>
    <div class="mt-5 d-flex justify-content-center" v-if="!studyIsSubmitted">
        <v-wait :for="loaderId" :visible="loading">
            <template slot="waiting">
                <HalfCircleSpinner/>
                <div class="spinner-message my-3 text-center">
                    Loading...
                </div>
            </template>
            <template>
                <div
                        class="v3_box_teal v3_box_teal_header current-study-container d-flex flex-column align-items-center"
                >
                    <template v-if="content && content.header">
                        <p v-html="content.header"/>
                    </template>
                    <template v-else>
                        <p>
                            <b>{{ subspecialtyName }} Value Study</b>
                        </p>
                    </template>
                    <!---- If questionnaire has prior year study -->
                    <!-- <template v-if="!this.isButtonTextBeginStudy">
                        <div class="text-left">
                            <p>Welcome back!</p>
                            <p>We hope Phairify’s data and personalized benchmarking has proven an invaluable professional resource.</p>
                            <p>We’ve made updating your information and accessing specialty information even easier than last year. Click Update Responses to continue.</p>
                            <p>(By clicking "Update Responses" and continuing, you agree not to use the compensation data for research or publishing purposes or use data other than for your personal use. If you wish to obtain more granular data for research or publication purposes, you agree to follow your specialty society’s guidelines and instructions.)</p>
                        </div>
                    </template> -->
                    <template v-if="content && content.body">
                        <div v-html="content.body"/>
                    </template>
                    <template v-else>
                        <p>Join your peers and power the Physician Value Exchange</p>
                        <p>
                            Complete your specialty Value Study to open and immediately access all
                            {{ subspecialtyName }} data, filters, and tools.
                        </p>
                        <p>
                            By clicking “{{ buttonTitle }}" below and participating in this study, you agree not to use the compensation data for research or publishing purposes or use data other than
                            for your personal use. If you wish to obtain more granular data for research or publication purposes, you agree to follow your societies' instructions.
                        </p>
                    </template>
                    <b-button
                            v-if="!studyIsSubmitted"
                            variant="kowloon"
                            class="mr-2 mb-2 mb-lg-0"
                            :disabled="beginLoading"
                            @click="onStudyClick"
                    >
                        <b-spinner v-if="beginLoading" small/>
                        <span v-else>{{ buttonTitle }}</span>
                    </b-button>
                </div>
            </template>
        </v-wait>
    </div>
</template>

<script>
import {HalfCircleSpinner} from 'epic-spinners';
import Api from '@/providers/Api';
import {CREATE_SURVEY_ACTION} from '@/store';
import {handleServerErrorWithValidation} from '@/helpers/ToastedHelper';

export default {
    name: 'CurrentStudySection',
    components: {
        HalfCircleSpinner,
    },
    props: {
        society: Object,
        user: Object,
        questionnaire: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            default: null,
        },
        study: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            default: null,
        },
        isButtonTextBeginStudy: Boolean,
    },
    data: function () {
        return {
            beginLoading: false,
            content: null,
            isUpdateData:false,
            isPriorYearStudy: false,
        };
    },
    created: function () {
        this.getContent();
        if(this.questionnaire && this.questionnaire.prior_year_questionnaire_id !== null)
        {
            this.isPriorYearStudy=true;
        }
    },
    computed: {
        loaderId: function () {
            return `loading_${this.$options.name}`;
        },
        loading: function () {
            return this.questionnaire === null;
        },
        subspecialtyName: function () {
            return (this.user.subspecialty || {}).title;
        },
        buttonTitle: function () {
            this.setUpdateData();
            if(this.isButtonTextBeginStudy === false){
                return 'Update Responses';
            }else{
                return this.study ? 'Continue Study' : 'Begin Study'; 
            }
            // if(this.completedSurvey === false){
            //     return this.study ? 'Continue Study' : 'Begin Study'; 
            // }else if(this.completedSurvey == true && this.questionnaire.prior_year_questionnaire_id !== null){
            //     return 'Update Responses';
            // }else if(this.completedSurvey == true && this.questionnaire.prior_year_questionnaire_id == null){
            //     return 'Continue Study';
            // }else{
            //     return 'Continue Study';  
            // }
            // if(this.questionnaire && this.questionnaire.prior_year_questionnaire_id !== null)
            // {
            //     //this.isUpdateData=true;
            //     return this.study ? 'Update Responses' : 'Update Responses';
            // }else{
            //     //this.isUpdateData=false;
            //     return this.study ? 'Continue Study' : 'Begin Study'; 
            // }
        },
        studyIsSubmitted: function () {            
            return this.study && this.study.submitted;
        },
    },
    methods: {
        setUpdateData: function () {

            if(this.isButtonTextBeginStudy === false){
                this.isUpdateData=true;
            }else{
                this.isUpdateData=false;
            }

            // if(this.completedSurvey == false){
            //     this.isUpdateData=false;
            // }else if(this.completedSurvey == true && this.questionnaire.prior_year_questionnaire_id !== null){
            //     this.isUpdateData=true;
            // }else if(this.completedSurvey == true && this.questionnaire.prior_year_questionnaire_id == null){
            //     this.isUpdateData=false;
            // }else{
            //     this.isUpdateData=false;
            // }

            // if(this.questionnaire && this.questionnaire.prior_year_questionnaire_id !== null)
            // {
            //     this.isUpdateData=true;
            // }else{
            //     this.isUpdateData=false;
            // }
        },
        onStudyClick: function () {
            if(this.isUpdateData){
                /* if user has prior year questionnaire_id is not null, permission to update
                 the current data */
               this.study ? this.continuePriorYearStudy() : this.beginPriorYearStudy();
            } else {
                this.study ? this.continueStudy() : this.beginStudy();
            }
            //this.study ? this.continueStudy() : this.beginStudy();
        },
        continueStudy: function () {
            this.$router.push(`/surveyForm/${this.questionnaire.survey.id}`);
        },
        beginStudy: async function () {
            this.beginLoading = true;
            try {
                const isUserProfileFilled = await Api.isUserProfileFilled();
                if (!isUserProfileFilled) {
                    this.$emit('fill-user-profile', this.questionnaire.id);
                    return;
                }
                const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
                    questionnaireId: this.questionnaire.id,
                });
                this.$router.push(`/surveyForm/${survey.id}`);
            } catch (e) {
                handleServerErrorWithValidation(e, this.$toasted);
            } finally {
                this.beginLoading = false;
            }
        },
        continuePriorYearStudy: function () {
            this.$router.push(`/update-prior-year-study/${this.questionnaire.survey.id}`);
        },
        beginPriorYearStudy: async function () {
            this.beginLoading = true;
            try {
                const isUserProfileFilled = await Api.isUserProfileFilled();
                if (!isUserProfileFilled) {
                    this.$emit('fill-user-profile', this.questionnaire.id);
                    return;
                }
                const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
                    questionnaireId: this.questionnaire.id,
                });
                this.$router.push(`/update-prior-year-study/${survey.id}`);
            } catch (e) {
                handleServerErrorWithValidation(e, this.$toasted);
            } finally {
                this.beginLoading = false;
            }
        },
        getContent: async function () {       
            this.$wait.start(this.loaderId);
            try {
                // if(this.questionnaire.prior_year_questionnaire_id && this.user.completed_surveys.length > 0)
                // {
                //     this.content = await Api.getPriorStudyMessage();
                // }else{
                //     this.content = await Api.getBeginStudyMessage();
                // }
                if(this.isButtonTextBeginStudy === false){
                    this.content = await Api.getPriorStudyMessage();
                }else{
                    this.content = await Api.getBeginStudyMessage();
                }
                this.content.body = this.content.body.replace('[BUTTON_TITLE]', '"' + this.buttonTitle + '"')
            } catch {
                this.$toasted.error(
                    'Unable to update page content. Please try again later',
                    {duration: 3000}
                );
            } finally {
                this.$wait.end(this.loaderId);                
            }
        }
    },
};
</script>

<style scoped lang="scss">
@import 'sass/variables_mixins.scss';

.current-study-container {
  padding: 50px;
  margin-top: -40px;
}
</style>
